import React from 'react'
import { Error } from '../../Services/Payment/Components'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import {
  CreditCardNumberInput,
  CreditCardExpirationDateInput,
  CreditCardPostalCodeInput,
  CreditCardCVVInput
} from 'react-square-payment-form'
import '../../Services/Payment/Form/square-payment-form.scss'

const Details = styled.div`
  display: flex;
  overflow: hidden;
`

const Errors = styled.div`
  margin-top: 20px;
`

const CCSection = ({ errors }) => (
  <Details>
    <fieldset className="sq-fieldset">
      <CreditCardNumberInput />
      <div>
        <div className="sq-form-expiration">
          <CreditCardExpirationDateInput />
        </div>
        <div className="sq-form-zip">
          <CreditCardPostalCodeInput />
        </div>
        <div className="sq-form-cvv">
          <CreditCardCVVInput />
        </div>
      </div>
      <Errors>
        {errors.length !== 0 && errors.map((error, i) => (
          <Error key={i}>
            <span>{error.message}</span>
          </Error>)
        )}
      </Errors>
    </fieldset>
  </Details>
)

CCSection.propTypes = {
  errors: PropTypes.array
}

export default CCSection
